import { render, staticRenderFns } from "./InstructorCard.vue?vue&type=template&id=13804dc4&scoped=true&"
import script from "./InstructorCard.vue?vue&type=script&lang=js&"
export * from "./InstructorCard.vue?vue&type=script&lang=js&"
import style0 from "./InstructorCard.vue?vue&type=style&index=0&id=13804dc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13804dc4",
  null
  
)

export default component.exports